import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";

@Injectable({
    providedIn: 'root'
})
export class BmQualityCheckRunResultService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/bm/qualityCheckRunResults')
    }
}
